import React from 'react'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

const BioTechPark = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <p className={styles.title}>Биотехнопарк в Вольгинском</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>Живи и учись <br />в научной среде</p>
          <div className={styles.desc}>
            <div className={styles.preview}>
              <p className={styles.text}>
                Последние полгода обучения пройдут в Вольгинском, где находится наш R&D-центр и производственные площадки.
              </p>
              <Link to='/relocation' className={styles.button}>
                Узнать о жизни в поселке <span>&rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.rightSide_iframe}>
          <iframe
            src='https://vk.com/video_ext.php?oid=-221108214&id=456239039&hash=819aa917002d46a4'
            title='VK video player'
            allow='autoplay; encrypted-media; fullscreen; picture-in-picture'
            frameborder="0"
            allowfullscreen="1"
          />
        </div>
      </div>
     </div>
  )
}

export default BioTechPark
